// extracted by css-extract-rspack-plugin
export default {"table":"table-w9ZEQN"};